
window.axios = require('axios');

window.axios.defaults.headers.common['X-Requested-With'] = 'XMLHttpRequest';

import Vue from 'vue'
import { InertiaApp } from '@inertiajs/inertia-vue'
import Buefy from 'buefy'

import AppIcon from '~/components/base/Icon'

import VueWait from 'vue-wait'

Vue.component('app-icon', AppIcon)

Vue.config.productionTip = false

Vue.use(InertiaApp)
Vue.use(Buefy, {
  defaultIconPack: '',
  defaultIconComponent: 'app-icon',
  defaultToastPosition: 'is-bottom'
})
Vue.use(VueWait)

const app = document.getElementById('app')

new Vue({
  wait: new VueWait(),
  render: h => h(InertiaApp, {
    props: {
      initialPage: JSON.parse(app.dataset.page),
      resolveComponent: name => import(`~/pages/${name}`).then(module => module.default),
    },
  })
}).$mount(app)